import TopicTwo from "../../../components/platform-contents/meta-trader-5-mobile-contents/TopicTwo";

const MetaTrader5MobileContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__platform">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Choose MetaTrader 5 Mobile with The Pips</h1>
            <p>
              Combining MetaTrader’s advanced infrastructure with The Pips’
              market expertise, this mobile solution empowers traders with
              performance, speed, and security on the go.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Cross-Device Synchronization</h4>
                </div>
                <p>
                  All data, trades, and charts are synced between mobile,
                  desktop, and web, so you never miss a beat.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Institutional-Grade Security</h4>
                </div>
                <p>
                  Built with bank-level encryption and multi-layer protection to
                  ensure every transaction remains safe.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Optimized for Performance</h4>
                </div>
                <p>
                  Lightweight design ensures smooth performance, low latency,
                  and fast execution, even under market volatility.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaTrader5MobileContentFive;
